import * as React from 'react';

import { Icon } from '../icon/icon.tsx';

import ClientLogoPlaceholder from '../menu-wrapper/Your-Logo-Here.svg';

import { useDevice, useWindowSize } from '../hooks.tsx';

import './menu-header.css';

interface MenuHeaderProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'onClick'
> {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const MenuHeader = React.forwardRef<HTMLDivElement, MenuHeaderProps>(
  ({ onClick, ...props }, ref) => {
    const dimensions = useWindowSize();
    const device = useDevice(dimensions);

    return (
      <div className="menu-header" ref={ref} {...props}>
        {device === 'mobile' && (
          <button
            type="button"
            className="menu-header-icon"
            onClick={onClick}
            title="Close"
          >
            <Icon type="x" size="large" color="var(--color_neutral-dark)" />
          </button>
        )}
        <img src={ClientLogoPlaceholder} alt="Client logo placeholder" />
        <div className="menu-header-text">
          Powered by Gemini Diversified Services
        </div>
      </div>
    );
  },
);

export { MenuHeader };
